import { useMutation } from "@apollo/client";

import { ProtocolCourseDeleteInput } from "~/__generated__";
import { COURSE_GET_ALL } from "~/modules/settings/course/routes/CourseListRoute/api/useCourseListRoute_GetAll";

import { ProtocolEditRoute_CourseDeleteDocument } from "../mutations.generated";
import { PROTOCOL_GET_BY_ID } from "./useProtocolEditRoute_GetById";

export const PROTOCOL_COURSE_DELETE = ProtocolEditRoute_CourseDeleteDocument;

export default function useProtocolCourseDelete() {
    const [deleteProtocolCourseMutation, { loading, error, data }] = useMutation(PROTOCOL_COURSE_DELETE, {
        refetchQueries: [PROTOCOL_GET_BY_ID, COURSE_GET_ALL],
    });

    const deleteProtocolCourse = async (input: ProtocolCourseDeleteInput) => {
        const response = await deleteProtocolCourseMutation({
            variables: { input },
        });

        return response.data?.protocolCourseDelete;
    };

    return {
        loading,
        error,
        data: data?.protocolCourseDelete,
        deleteProtocolCourse,
    };
}
